import React from 'react';
import SchemaViewerApp from '../../submodules/wrangler/apps/schema-viewer-app/src/App';
import '../../submodules/wrangler/apps/schema-viewer-app/src/App.css';
import '../../submodules/wrangler/apps/schema-viewer-app/src/index.css';

function SchemaViewer() {
    // The schema viewer app expects the schema to be available at /api/schemas/bdsa-schema
    // We've copied bdsa-schema.json to public/assets, but the app expects it at a different path
    // This should work if the backend API endpoint exists, otherwise we may need to set up a proxy
    return (
        <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
            <SchemaViewerApp />
        </div>
    );
}

export default SchemaViewer;

